export const API_GENERATE_API_KEY_SUCCESS = "API_GENERATE_API_KEY_SUCCESS";
export const API_GENERATE_API_KEY_FAIL = "API_GENERATE_API_KEY_FAIL";
export const GET_GENERATE_API_KEY = "GET_GENERATE_API_KEY";
